import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import {
  PwaApp,
  PwaInstallLanding,
  captureInstallPrompt,
  isPwaMode,
  registerServiceWorker,
  shouldShowInstallLanding,
} from './pwa';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Instalada como PWA en un celular → la app mobile. En el navegador de un celular → solo la landing "Instalá la app" (la plataforma
// web no se usa desde el celular). En el resto (desktop, tablets) → la plataforma completa (instalada en una tablet, con el bloqueo por
// notificaciones: ver `InstalledTabletPushGate`).
if (isPwaMode()) {
  root.render(<PwaApp />);
} else if (shouldShowInstallLanding()) {
  // El navegador avisa que se puede instalar con un evento que puede llegar antes de que se dibuje la pantalla: se escucha desde ya.
  captureInstallPrompt();
  root.render(<PwaInstallLanding />);
} else {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

registerServiceWorker();
